import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { getControl, getGroup } from '@shared/helpers/form.helper';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { revisione53DatiFormSelectors } from '../../../store/selectors/dati-form.selectors';
import { formPaths } from '@shared/constants/form-paths.const';

const SCHEDA_PREV_PATH = `${formPaths.naturaMutualistica}.my_SchedaPrevalenza`;

const BIL_ANNO_1_CONTROLS = [
    'my_CkOffreBeniServCoopAttPrimoAnno',
    'my_CkOffreOccLavSociCoopAttPrimoAnno',
    'my_CkRemunConferProdSociCoopAttPrimoAnno',
    'my_CkRemunPrestConfServSociCoopAttPrimoAnno',
];

const BIL_ANNO_2_CONTROLS = [
    'my_CkOffreBeniServCoopAtt',
    'my_CkOffreOccLavSociCoopAtt',
    'my_CkRemunConferProdSociCoopAtt',
    'my_CkRemunPrestConfServSociCoopAtt',
];

const BILANCIO_ALLEGATO_CONTROLS = [
    'my_A1versoSociPrimoAnno',
    'my_A1versoSoci',
    'my_TotaleA1PrimoAnno',
    'my_TotaleA1',
    'my_B9versoSociPrimoAnno',
    'my_B9versoSoci',
    'my_TotaleB9PrimoAnno',
    'my_TotaleB9',
    'my_CkValoreQuantitaPrimoAnno',
    'my_CkValoreQuantita',
    'my_B6confSociPrimoAnno',
    'my_B6confSoci',
    'my_TotaleB6PrimoAnno',
    'my_TotaleB6',
    'my_QtaConfSociPrimoAnno',
    'my_QtaConfSoci',
    'my_TotQtaConfSociPrimoAnno',
    'my_TotQtaConfSoci',
    'my_B7ricevSociPrimoAnno',
    'my_B7ricevSoci',
    'my_TotaleB7PrimoAnno',
    'my_TotaleB7',
];

export const setNatMutEnableDisableListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    manageBilAnno1DisabledControls(form, store);
    manageBilAnno2DisabledControls(form, store);
    manageBilancioAllegatoDisabledControls(form, store);
};

const applyEnableDisable = (form: FormGroup, paths: string[], disable: boolean): void => {
    const group = getGroup(form, SCHEDA_PREV_PATH);
    paths.forEach((path) => {
        const control = getControl(group, path);
        if (disable) {
            control.disable({ emitEvent: false });
        } else {
            control.enable({ emitEvent: false });
        }
    });
};

const manageBilAnno1DisabledControls = (form: FormGroup, store: Store<Revisione53State>): void => {
    store.select(revisione53DatiFormSelectors.my_BilAnno1DisablingCondition).subscribe((condition) => {
        applyEnableDisable(form, BIL_ANNO_1_CONTROLS, condition);
    });
};

const manageBilAnno2DisabledControls = (form: FormGroup, store: Store<Revisione53State>): void => {
    store.select(revisione53DatiFormSelectors.my_BilAnno2DisablingCondition).subscribe((condition) => {
        applyEnableDisable(form, BIL_ANNO_2_CONTROLS, condition);
    });
};

const manageBilancioAllegatoDisabledControls = (form: FormGroup, store: Store<Revisione53State>): void => {
    store.select(revisione53DatiFormSelectors.isBilancioAllegatoEmpty).subscribe((isBilancioAllegatoEmpty) => {
        applyEnableDisable(form, BILANCIO_ALLEGATO_CONTROLS, isBilancioAllegatoEmpty);
    });
};
